import React from "react";
import useWindowDimensions from "../../../get-diemensions/UseWindowDiemensions";
import { NearestButton } from "../../../components";
import { BaseButton } from "../../../components/atoms";
import { colors } from "../../../themes/Colors";
import { useNavigate } from "react-router-dom";

const NearStore = ({ onContactClick }) => {
  const { width, height } = useWindowDimensions();
  const navigate = useNavigate();
  return (
    <div
      style={{
        width: width,
        maxWidth: 1440,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        marginTop: 0,
        paddingBottom: 10,
        backgroundColor: colors.white,
      }}
    >
      <h2
        style={{
          paddingBottom: 20,
          marginTop: 60,
          textAlign: width > 599 ? "center" : "center",
        }}
      >
        Find Your Nearest Affiliated Location
      </h2>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
        }}
      >
        <div
          style={{
            width: "100%",

            display: "flex",

            minHeight: 200,
            justifyContent: "center",
            alignItems: "center",
            flexDirection: width > 599 ? "row" : "column",
          }}
        >
          <NearestButton
            title={"Designated Pharmacies"}
            backgroundImage={require("../../../images/landing/designatedPhramacies.png")}
            medicalInfoImage={require("../../../images/landing/southAfricanPharmacyCouncil.jpg")}
            height={60}
            width={180}
            onViewClick={() => navigate("/pharmacies")}
            mobileHeight={width > 599 ? null : 250}
            mobileWidth={width > 599 ? null : width - 20}
          />{" "}
          <div style={{ minWidth: 20, minHeight: width > 599 ? 0 : 40 }} />{" "}
          <NearestButton
            title={"Registered Medical Practitioners"}
            backgroundImage={require("../../../images/landing/registeredMedicalPractioners.png")}
            medicalInfoImage={require("../../../images/landing/hpcsa.png")}
            height={60}
            width={180}
            mobileHeight={width > 599 ? null : 250}
            mobileWidth={width > 599 ? null : width - 20}
          />
        </div>
      </div>

      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginTop: 20,
          marginBottom: 40,
        }}
      >
        <BaseButton
          label={"Get in touch"}
          marginRight={20}
          width={180}
          onClick={onContactClick}
        />
      </div>
    </div>
  );
};

export default NearStore;
